import { getSenderAccessToken } from '@/api/sender-http';
import { $features } from '@/entities/features-entity';
import { formatApiError } from '@/lib/format-api-error';
import axios from 'axios';
import { useUnit } from 'effector-react';
import { useCallback, useEffect, useState } from 'react';

export function useSenderAccess() {
	const features = useUnit($features);
	const enabled = features.senderEnabled;
	const [accessible, setAccessible] = useState(false);
	const [loading, setLoading] = useState(enabled);
	const [error, setError] = useState<string | null>(null);

	const verifyAccess = useCallback(async () => {
		if (!enabled) {
			setAccessible(false);
			setLoading(false);
			setError(null);
			return;
		}

		setLoading(true);
		setError(null);
		try {
			await getSenderAccessToken();
			setAccessible(true);
		} catch (err) {
			setAccessible(false);
			if (axios.isAxiosError(err)) {
				setError(formatApiError(err.response?.data) ?? 'Не удалось получить доступ к sender');
			} else {
				setError('Не удалось получить доступ к sender');
			}
		} finally {
			setLoading(false);
		}
	}, [enabled]);

	useEffect(() => {
		void verifyAccess();
	}, [verifyAccess]);

	return { enabled, accessible, loading, error, retry: verifyAccess };
}
